import React from "react";
import PropTypes from "prop-types";

// styles
import { ContentStyled } from "./styles";

// component
export const Content = ({ children, isOpen, contentMaxHeight }) => {
    return (
        <ContentStyled $isOpen={isOpen} $contentMaxHeight={contentMaxHeight}>
            {children}
        </ContentStyled>
    );
};

export default Content;

// prop-types
Content.propTypes = {
    children: PropTypes.any,
    isOpen: PropTypes.bool.isRequired,
    contentMaxHeight: PropTypes.number.isRequired
};
